import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Matelas from "@/pages/Matelas";
import DynamicPage from "@/pages/DynamicPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/context/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <LanguageProvider>
                        <Routes>
                            {/* French — no prefix */}
                            <Route path="/" element={<Landing />} />
                            <Route path="/matelas" element={<Matelas />} />
                            {/* Dutch */}
                            <Route path="/nl" element={<Landing />} />
                            <Route path="/nl/matelas" element={<Matelas />} />
                            {/* English */}
                            <Route path="/en" element={<Landing />} />
                            <Route path="/en/matelas" element={<Matelas />} />
                            {/* Admin */}
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            {/* Dynamic custom pages (must stay last — after all explicit routes) */}
                            <Route path="/:slug" element={<DynamicPage />} />
                            <Route path="/nl/:slug" element={<DynamicPage />} />
                            <Route path="/en/:slug" element={<DynamicPage />} />
                        </Routes>
                    </LanguageProvider>
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="bottom-right" />
        </div>
    );
}

export default App;
